import { createSlice } from "@reduxjs/toolkit";

export const fullPageLoaderSlice = createSlice({
  name: "fullPageLoader",
  initialState: {
    fullPageLoading: false,
  },
  reducers: {
    setFullPageLoader: (state, action) => {
      state.fullPageLoading = action.payload;
    },
  },
});

export const { setFullPageLoader } = fullPageLoaderSlice.actions;

export default fullPageLoaderSlice.reducer;
